import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../../providers/config.service';
import { FranchiseAppGlobal } from 'src/app/franchise-app-global';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit {
  @Input('currentLang') currentLang: string;
  private env;
  constructor(public http: HttpClient, private config: AppConfigService) {
    this.env = this.config.getConfig();
  }

  ngOnInit() {
  }

  downloadUserManual() {
    let url = this.env.baseUrl + FranchiseAppGlobal.downloadUserManual;
    this.http.get(url, { responseType: 'blob' }).subscribe(
      blob => {
        saveAs(blob, "Franchise_Usermanual.pdf" /*, { type: 'text/plain;charset=windows-1252' }*/);
      },
      error => { }
    );
  }

}
